'use strict';

var GridRefreshButtonDirective = function GridRefreshButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-refresh-button.html'),
    controller: 'GridRefreshButtonController',
    link: function link($scope, element) {
      var gridPanel = $scope.gridPanelScope;
      var notificationTooltip;
      function setLastRefreshedTitle() {
        element.attr('title', $scope.getLastRefreshedNotification());
      }
      if (!gridPanel.isLiveData) {
        $scope.$watch('gridPanelScope.lastRefreshed', setLastRefreshedTitle);
      } else {
        notificationTooltip = element.find('.live-data-notification');
        notificationTooltip.popover({
          container: 'body'
        });
        element.hover(function () {
          if (!$scope.isDisabled() && $scope.isNotificationShown()) {
            notificationTooltip.popover('show');
          }
        }, function () {
          notificationTooltip.popover('hide');
        });
      }
      $scope.$watch('liveDataNotification.total', function () {
        if (notificationTooltip) {
          notificationTooltip.popover('hide');
        }
      });
    }
  };
};
GridRefreshButtonDirective.$inject = [];
module.exports = GridRefreshButtonDirective;